import nodeAPI from "../../service/ApiServiceNode";

async function listPending(_args, ctx) {
    const res = await nodeAPI.get("/leave/pending-approvals");
    const approvals = res?.data?.data?.approvals || res?.data?.approvals || [];
    ctx.actions.setLeavePending(approvals);
    return { ok: true, count: approvals.length, approvals };
}

function readNext(_args, ctx) {
    const state = ctx.store.getState();
    const item = state.leavePending[state.leaveCursor] || null;
    if (!item) return { ok: true, done: true, detail: "No more pending leave requests." };
    ctx.actions.setLeaveCursor(state.leaveCursor + 1);
    return { ok: true, request: item, index: state.leaveCursor + 1, total: state.leavePending.length };
}

function findPendingLeave(state, id) {
    const numericId = Number(id);
    return (state.leavePending || []).find((item) => Number(item.id) === numericId) || { id: numericId };
}

function approve({ id }, ctx) {
    if (!id) return { ok: false, detail: "id is required" };
    const state = ctx.store.getState();
    const request = findPendingLeave(state, id);
    ctx.actions.setLeaveDecision({ action: "approve", id: Number(id), request });
    return {
        ok: true,
        staged: true,
        action: "approve",
        id: Number(id),
        detail: "Approval staged. Ask the user to confirm before committing.",
    };
}

function reject({ id, reason }, ctx) {
    if (!id) return { ok: false, detail: "id is required" };
    const state = ctx.store.getState();
    const request = findPendingLeave(state, id);
    ctx.actions.setLeaveDecision({ action: "reject", id: Number(id), reason: reason || "", request });
    return {
        ok: true,
        staged: true,
        action: "reject",
        id: Number(id),
        reason: reason || "",
        detail: "Rejection staged. Ask the user to confirm before committing.",
    };
}

async function commitDecision(_args, ctx) {
    const decision = ctx.store.getState().leaveDecision;
    if (!decision?.id || !["approve", "reject"].includes(decision.action)) {
        return { ok: false, detail: "No staged leave approval decision to commit" };
    }

    const encodedId = encodeURIComponent(decision.id);
    const res = decision.action === "approve"
        ? await nodeAPI.post(`/leave/pending-approvals/${encodedId}/approve`)
        : await nodeAPI.post(`/leave/pending-approvals/${encodedId}/reject`, { reason: decision.reason || "" });

    ctx.actions.setLeaveDecision(null);
    await listPending({}, ctx);
    return { ok: true, action: decision.action, id: decision.id, result: res?.data?.data || res?.data };
}

export const leaveTools = [
    {
        key: "leave.list_pending",
        schema: {
            type: "function",
            description: "List leave requests awaiting the current user's approval.",
            parameters: { type: "object", properties: {} }
        },
        executor: listPending
    },
    {
        key: "leave.read_next",
        schema: {
            type: "function",
            description: "Return the next pending leave request from the current list.",
            parameters: { type: "object", properties: {} }
        },
        executor: readNext
    },
    {
        key: "leave.approve",
        schema: {
            type: "function",
            description: "Stage approval for a pending leave request by id. This does not call the approval API; ask the user to confirm, then call leave.commit_decision.",
            parameters: {
                type: "object",
                properties: { id: { type: "number" } },
                required: ["id"]
            }
        },
        executor: approve
    },
    {
        key: "leave.reject",
        schema: {
            type: "function",
            description: "Stage rejection for a pending leave request by id. This does not call the rejection API; ask the user to confirm, then call leave.commit_decision.",
            parameters: {
                type: "object",
                properties: {
                    id: { type: "number" },
                    reason: { type: "string" }
                },
                required: ["id"]
            }
        },
        executor: reject
    },
    {
        key: "leave.commit_decision",
        schema: {
            type: "function",
            description: "Commit the staged leave approval or rejection only after explicit user confirmation.",
            parameters: { type: "object", properties: {} }
        },
        executor: commitDecision
    }
];
